import * as Sentry from "@sentry/react";

const WarningLevel = {
  WARNING: "warning",
  INFO: "info",
} as const;

type WarningLevel = (typeof WarningLevel)[keyof typeof WarningLevel];

const sentry = {
  /**
   * 報告警示訊息到 Sentry
   * @param message - 警示訊息內容
   * @param level - 警示級別 (warning | info)
   * @param context - 額外的上下文資訊
   */
  reportWarning: (
    message: string,
    level: WarningLevel = WarningLevel.WARNING,
    context?: Record<string, any>,
  ) => {
    Sentry.captureMessage(message, {
      level: level as Sentry.SeverityLevel,
      contexts: context ?? {},
    });
  },
};

export default sentry;
export { WarningLevel };
